export const DRAW_LAYER_ID = "draw_layer";
export const DRAW_FEATURE_KEY = "draw_feature";
export const DRAW_SOURCE_ID = "draw_source";
export const EDIT_SOURCE_ID = "edit-vertices-source";

export const DRAW_DRAWING_FEATURE_COLOR = "rgba(251, 191, 36, 0.2)";
export const DRAW_DRAWING_FEATURE_STROKE_COLOR = "rgba(251, 191, 36, 0.5)";
export const DRAW_DRAWING_FEATURE_STROKE_WIDTH = 2;

export const DRAW_MODIFY_FEATURE_COLOR = "rgba(255, 255, 0, 0.2)";
export const DRAW_MODIFY_FEATURE_STROKE_COLOR = "rgba(255, 255, 0, 0.5)";
export const DRAW_MODIFY_FEATURE_STROKE_WIDTH = 2;

export const DRAW_FEATURE_COLOR = "rgba(255, 0, 255, 0.7)";
export const DRAW_FEATURE_STROKE_COLOR = "rgba(255, 0, 255, 1)";
export const DRAW_FEATURE_STROKE_WIDTH = 2;
